import { Compass, Hammer } from 'lucide-react';
import { Link } from 'react-router';
import { MODULE_TITLES, tr, type ModuleKey } from '@kts/shared';
import { useLocale, useT } from '@kts/i18n';
import { Button, Card, EmptyState } from '@kts/ui';

export function NotFoundPage() {
  const t = useT('app');
  return (
    <div style={{ minHeight: '70vh', display: 'grid', placeItems: 'center' }}>
      <EmptyState
        icon={<Compass />}
        title={t('notFound.title')}
        description={t('notFound.description')}
        action={
          <Link to="/">
            <Button variant="primary">{t('notFound.home')}</Button>
          </Link>
        }
      />
    </div>
  );
}

/** Modul hali qurilayotgan bo'lsa (yangi bloklar shu joydan boshlanadi). */
export function ComingSoon({ module, title }: { module: ModuleKey; title?: string }) {
  const t = useT('app');
  const locale = useLocale();
  return (
    <Card>
      <EmptyState icon={<Hammer />} title={title ?? tr(MODULE_TITLES[module], locale)} description={t('comingSoon.description')} />
    </Card>
  );
}
